/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../nb');
var util = require('../util');
var io = require('../io/' + process.env.APP_ENV + '/io');
var Model = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            nb.model.onChange(nb.opts.clientReady, function () {

                var token = $.cookie('asc_b2b_token');         //用户唯一标示
                var userName = $.cookie('asc_b2b_userName');   //用户名
                var companyId = $.cookie('asc_b2b_companyId');       //公司ID
                var companyType = $.cookie('asc_b2b_companyType');   //公司类型
                var userId = $.cookie('asc_b2b_userId');       //userId
                var userType = $.cookie('asc_b2b_userType');   //用户类型
                var userState = $.cookie('asc_b2b_userState');   //有无企业信息
                var onlyWater = $.cookie('asc_b2b_onlyWater') || '';   //菜单
                this.setOpts({
                    userName: userName, //
                    userId:userId,
                    companyId:companyId,
                    companyType:companyType,
                    userType: userType,
                    userState: userState,
                    onlyWater:onlyWater,
                    token: token
                });
            }, this);
            this.onChange('token', function (inEvent, inToken) {
                var isOnlyWater = this.get('isOnlyWater');
                var onlyWater = this.get('onlyWater');
                var isPageLogin = this.get('isPageLogin');
                var checkCompleteInfo = this.get('checkCompleteInfo');  // 不需要公司信息验证页面return false 需要return true
                var userState = this.get('userState');
                if (inToken) {
                    io.setToken(inToken);
                    //未填写公司信息 并且true    userState =='0'                     //(userState =='1' || userState =='2' || userState =='3')
                    if ((userState ==='1' || userState ==='2' || userState ==='3'|| userState ==='6')   && checkCompleteInfo) { //1 == 1 || userState ==2 || userState ==3
                        window.location.href="companyInfo.html";
                    }
                    this.set('loginReady', true);
                } else {
                    //登录
                    if (isPageLogin) {
                        window.location.href = 'login.html';
                        return false;
                    }
                    this.set('loginReady', false);
                }
                if(isOnlyWater && onlyWater == 'true'){
                    window.location.href="inquiryList.html";
                }

            }, this);
            nb.model.onChange('logOff', function () {
                util.clearCookie();
                window.location.href = 'login.html'
            }, this);

        }
    }
});
var model = new Model;
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/User.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39